import React, { Component } from 'react';
import LibraryList from '../LibraryList';
import NavigationTabs from '../nav/NavigationTabs'
import { COLORS } from '../../styles/colors';
import { WORKOUT_LIBRARY_MESSAGE } from '../../static-content';
import { paginationLimit } from './../../helpers.js'
/**
 * List
 */
export class List extends Component { // eslint-disable-line react/prefer-stateless-function
  state = {
    dataLoaded: false,
    editItem: null
  }

  componentDidMount() {
    setTimeout(() => {
      this.props.resetWorkouts();
      this.fetchworkouts();
    }, 1000);
  }

  componentWillUnmount() {
    this.props.resetWorkouts();
    this.props.resetWorkoutInfo();
  }

  fetchworkouts() {
    this.props.fetchListData({
      creatorId: this.props.user._id || localStorage.id,
      isArchive: false,
      limit: paginationLimit.TEN,
      skip: 0
    }).then(() => {
      this.setState({
        ...this.state,
        dataLoaded: true
      })
    });
  }

  fetchList() {
    this.setState({
      dataLoaded: false
    });
    this.fetchworkouts();
  }

  reorder = (items, reqOrders) => {
    this.props.updateOrder(reqOrders, items)
  };

  render() {
    const { workouts, workoutCats, user, isLoadMoreListing, fetchMoreWorkouts, resetWorkouts } = this.props;
    return (
      <div>
        <NavigationTabs
          title="Library"
          subtitle="Workouts"
          description={WORKOUT_LIBRARY_MESSAGE}
          set="library"
          activeRoute="/library/workouts"
        />
        {this.state.dataLoaded &&
          <div style={{ marginTop: 10, border: '1px solid ' + COLORS.grey }}>
            <LibraryList
              items={Object.values(workouts)}
              categories={workoutCats}
              categoryField="categoryId"
              creatorTabs={true}
              user={user}
              itemType="workout"
              fetchworkouts={() => this.fetchList()}
              isLoadMoreListing = {isLoadMoreListing}
              fetchMoreListing = {fetchMoreWorkouts}
              resetListing = {resetWorkouts}
              reorder={this.reorder}
            />
          </div>
        }
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/components/workouts/List.js